const StateMenu = {
    dark: false,
    menu: {
        admin:[
            {title:'Cliente',icon:'mdi-card-account-details',to:'empresa'},
            {title:'Produto',icon:'mdi-tag-multiple',to:'produto'},
            {title:'Pedidos',icon:'mdi-ticket-confirmation',to:'pedidos'},
        ],
        cliente:[
            {title:'Produto',icon:'mdi-tag-multiple',to:'produto'},
            {title:'Pedidos',icon:'mdi-ticket-confirmation',to:'pedidos'},
        ]
    }
}
const GettersMenu = {
    isDark (state) {
        return state.dark;
    },
    listMenuAdmin: (state) => state.menu.admin,
    listMenuCliente: (state) => state.menu.cliente,
    menuAtivo: (state) => state.menu.admin,
    getPreferThemeUser: () => {
        let theme = 0;
        if(Object.prototype.hasOwnProperty.call(localStorage,'_theme_prefer')) {
         theme = (localStorage.getItem('_theme_prefer')==1) ? true : false
        }
        return theme
    }
}
const MutationsMenu = {
    darkOn: state => state.dark = true,
    lightOn: state => state.dark = false,
    addReports: (state, payload) => state.menu.push(payload),

}
const ActionsMenu = {
    darkOn (context) {
        localStorage.setItem('_theme_prefer',1)
        context.commit('darkOn');
    },
    lightOn (context) {
        localStorage.setItem('_theme_prefer',0)
        context.commit('lightOn');
    },
    addReports (context, payload) {
        context.commit('addReports', payload);
    },
    loadMenu () {
        //adicionar axio para busca dos relatorios
    },
    loadPreferenciasUser(context){
        if(!Object.prototype.hasOwnProperty.call(localStorage,'_theme_prefer')) {
            localStorage.setItem('_theme_prefer',0)
        }
        let info = localStorage.getItem('_theme_prefer')
        if(info==1) {
            context.commit('darkOn')
        }else{
            context.commit('lightOn')
        }
    }
}

export { StateMenu, GettersMenu, MutationsMenu, ActionsMenu } 